import { useContext } from 'react'
import { context } from '~/components/LanguageProvider'

const useLanguage = () => useContext(context)

export default useLanguage
